export const formatNumericHumanDate = (date: Date) =>
	`${date.getDate()}.\xA0${date.getMonth() + 1}.\xA0${date.getFullYear()}`;
